'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var types = require('./types.js');

// eslint-disable-next-line import/prefer-default-export
var getStatusColors = function (yellow, green, red, blue) {
    var _a;
    return (_a = {},
        _a[types.AppointmentRequestStatusType.sentNoResponse] = yellow,
        _a[types.AppointmentRequestStatusType.sent] = yellow,
        _a[types.AppointmentRequestStatusType.readyForBooking] = green,
        _a[types.AppointmentRequestStatusType.failed] = red,
        _a[types.AppointmentRequestStatusType.inProgress] = yellow,
        _a[types.AppointmentRequestStatusType.queued] = blue,
        _a);
};

exports.getStatusColors = getStatusColors;
